import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Notification\GetNotificationListController::__invoke
* @see app/Http/Controllers/Notification/GetNotificationListController.php
* @route '/api/notification'
*/
const GetNotificationListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNotificationListController.url(options),
    method: 'get',
})

GetNotificationListController.definition = {
    methods: ["get","head"],
    url: '/api/notification',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Notification\GetNotificationListController::__invoke
* @see app/Http/Controllers/Notification/GetNotificationListController.php
* @route '/api/notification'
*/
GetNotificationListController.url = (options?: RouteQueryOptions) => {
    return GetNotificationListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Notification\GetNotificationListController::__invoke
* @see app/Http/Controllers/Notification/GetNotificationListController.php
* @route '/api/notification'
*/
GetNotificationListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNotificationListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Notification\GetNotificationListController::__invoke
* @see app/Http/Controllers/Notification/GetNotificationListController.php
* @route '/api/notification'
*/
GetNotificationListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetNotificationListController.url(options),
    method: 'head',
})

export default GetNotificationListController